let vm = null;
export function sendGameThis(_this) {
  vm = _this;
}
// isRoom 是否是创房 模式
export function payGameFun(opt, canTestPlay, replace, isRoom = "") {
  vm.$PayGame(opt.gameGroupSid, {
    canTestPlay: canTestPlay, // // canTestPlay 'STATUS_BOOL_TRUE' 进入试玩 'STATUS_BOOL_FALSE' 或者其他值进入正式。
    replace: replace, // 是否  路由 走replace 方法
    isRoom, //   //2 是创房   是否是 创房模式
    KillOffType: opt?.KillOffType, // 踢人接口走逻辑先后
    odds_style_id: opt?.odds_style_id, // 游戏bti 盘类型
    roomId: opt?.room_id, // 创房邀请链接过来的
    teamId: opt?.team_id, // 组队邀请链接过来的
    closeDialog: true,
    eid: opt?.oid || opt?.eid || "",
    isMatchKeys: opt.isRecommend || false,
  });
}
